var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label-class",attrs:{"for":"uploadFile"},on:{"click":_vm.clickFile}},[_c('a-icon',{style:({fontSize: '20px', color: 'rgba(0, 0, 0, 0.65)', marginLeft: '8px'}),attrs:{"type":"profile"}}),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file"},on:{"change":_vm.fileChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }